import React from "react";
import './index.less';
export default function Footer() {
	return (
		<footer className="footerBox">
			<div className="footerBox-bg"><div></div></div>
			<div className="footerBox-bottom">版权所有：深圳远东数智采技术服务有限公司          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">ICP备案号：粤ICP备2022095238号</a>         </div>
		</footer>
	);
}
